<div class="container">
  <div class="grain"></div>
  <div class="safe">
    <app-makna-header
      [title]="''"
      (onBackButtonClicked)="onBackButtonClicked()"
      width="3rem"
      height="3rem"
    />
  </div>
  <div class="content">
    <!-- ? Form -->
    <div class="form-container w-100">
      <div class="title">
        <span class="title-header">
          {{ 'LOGIN_TO_WEALTH' | translate }}
        </span>
        <span class="title-hint">
          {{ 'LOGIN_HINT' | translate }}
        </span>
      </div>

      <!-- ? Form -->
      <div>
        <!-- ? nationalId JUST For makna -->
        <div class="input-container">
          <div
            class="password-wrapper"
            [formGroup]="form"
          >
            <input
              type="text"
              [placeholder]="'NATIONAL_ID' | translate"
              class="password-input"
              formControlName="nationalId"
              maxlength="10"
              ngxTouchKeyboard
              (ngModelChange)="checkNationalID()"
              #touchKeyboard="ngxTouchKeyboard"
              inputmode="numeric"
            />

            <div class="input-icons">
              <div
                class="keyboard"
                (click)="touchKeyboard.togglePanel()"
              >
                <img
                  class="grid-icon"
                  src="wealth-assets/icons/keyboard.svg"
                />
              </div>
            </div>
          </div>

          @if (showError === 'show' && errorMessage) {
            <div class="national-id-error">
              <span>{{ errorMessage | translate }}</span>
            </div>
          }
        </div>
        <div class="password-container">
          <app-password-input
            [passwordInfo]="passwordInfo"
            (onInputChanged)="onPasswordChange($event)"
            [displayIndicator]="false"
          ></app-password-input>
        </div>
      </div>

      <!-- ? Forget password link -->
      <div class="forget-password">
        <span
          class="forget-password-link"
          (click)="onbuttonClick('FORGET_PASSWORD')"
        >
          {{ 'FORGET_PASSWORD' | translate }}
        </span>
      </div>

      @if (showRegister) {
        <p class="has-account">
          {{ 'NOT_REGISTERED' | translate }}
          <span
            class="register-link cursor-pointer"
            (click)="onbuttonClick('GO_TO_LOGIN')"
          >
            {{ 'REGISTER' | translate }}
          </span>
        </p>
      }

      <!-- ? Security hints -->
      <mat-accordion
        class="security-hints-container"
        #accordion
      >
        <mat-expansion-panel
          [expanded]="true"
          [disabled]="true"
          (afterExpand)="expanedClass = true"
          (afterCollapse)="expanedClass = false"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'SECURITY_HINTS' | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          @for (hint of securityHints; track hint.id; let i = $index) {
            <li>
              @if (i === 0) {
                {{ hint.text | translate: { site: site } }}
              } @else {
                {{ hint.text | translate }}
              }
            </li>
          }
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>

<!-- ? login action button -->
<div
  class="login-button-container"
  [ngClass]="{ 'expanded-mt': expanedClass }"
>
  <ngx-button
    [style]="'fill'"
    [fullWidth]="true"
    size="medium"
    [disabled]="!timeIsOver || password?.length < 8 || showError === 'show' || form.invalid || loading"
    (clickHandler)="onbuttonClick('LOGIN')"
  >
    @if (!timeIsOver) {
      <ngx-count-down
        [timeInSeconds]="otpSecounds"
        [type]="'mm:ss'"
        (finished)="timerFinish()"
      ></ngx-count-down>
    } @else {
      {{ 'LOGIN' | translate }}
    }
  </ngx-button>
</div>
